import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export interface MultiSessionLimitTemplate {
	activeFrom: string;
	limitValue: number;
	limitPeriod: string;
}

export enum MultiSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
	Yearly = 365,
}

export enum MultiSessionLimitSuggestionAmounts {
	Daily = 24,
	Weekly = 168,
	Monthly = 720,
	Yearly = 8760,
}

export enum MultiSessionLimitPeriodTranslationsEnum {
	Daily = "dailySessionLimit",
	Weekly = "weeklySessionLimit",
	Monthly = "monthlySessionLimit",
	Yearly = "yearlySessionLimit",
}

export const multiSessionLimitPeriodToSuggestionAmount: Record<
	MultiSessionLimitPeriod,
	MultiSessionLimitSuggestionAmounts
> = {
	[MultiSessionLimitPeriod.Daily]: MultiSessionLimitSuggestionAmounts.Daily,
	[MultiSessionLimitPeriod.Weekly]: MultiSessionLimitSuggestionAmounts.Weekly,
	[MultiSessionLimitPeriod.Monthly]: MultiSessionLimitSuggestionAmounts.Monthly,
	[MultiSessionLimitPeriod.Yearly]: MultiSessionLimitSuggestionAmounts.Yearly,
};

export const multiSessionLimitPeriodToPeriodTranslation: Record<
	MultiSessionLimitPeriod,
	MultiSessionLimitPeriodTranslationsEnum
> = {
	[MultiSessionLimitPeriod.Daily]: MultiSessionLimitPeriodTranslationsEnum.Daily,
	[MultiSessionLimitPeriod.Weekly]: MultiSessionLimitPeriodTranslationsEnum.Weekly,
	[MultiSessionLimitPeriod.Monthly]: MultiSessionLimitPeriodTranslationsEnum.Monthly,
	[MultiSessionLimitPeriod.Yearly]: MultiSessionLimitPeriodTranslationsEnum.Yearly,
};

export interface MultiSessionLimitFormGroup extends UntypedFormGroup {
	controls: {
		sessionLimitAmount: UntypedFormControl;
		sessionLimitPeriod: UntypedFormControl;
	};
}
